class Notice {
    _item;

    constructor(item) {
        this._item = item || {};
    }

    get raw() {
        return this._item;
    }

    get key() {
        return this._item.noticeId
    }
}

export default Notice